import { isNil } from 'lodash';
import { DateRangeField } from '@shared/data/entity/fields/DateRangeField';
import {
  isCombinedTagsComponent,
  isDateRangeComponent,
  isRelatedCardLookupComponent,
} from '@shared/scenes/workflows/utils';
import { API } from '@shared/types/api';
import { User } from '@shared/types/user';
import { CombinedTagsField } from '../entity/fields/CombinedTagsField';
import { Field } from '../entity/fields/Field';
import { GenericUntypedJsonBlobField } from '../entity/fields/GenericUntypedJsonBlobField';
import { RelatedLookupField } from '../entity/fields/RelatedLookupField';
import { fieldFromComponentData } from '../entity/fields/fieldFromComponentData';

interface BuildCardFieldProps {
  entity: API.WorkflowEntity | null;
  component: API.AnyComponent;
  refs: NonNullable<NonNullable<API.ListWorkflowEntitiesQuery['list']>['refs']>;
  defaultData?: any;
  currentUser?: User;
}

export function buildCardField({
  entity,
  component,
  refs,
  defaultData,
  currentUser,
}: BuildCardFieldProps): Field | null {
  const data = entity?.fields?.[component.id] ?? defaultData;

  // Entity-level derivations that need the full entity object
  if (isRelatedCardLookupComponent(component) && entity) {
    return RelatedLookupField.fromEntity(entity, component, refs);
  }
  if (isCombinedTagsComponent(component) && entity) {
    return new CombinedTagsField(component.componentIds, entity);
  }
  if (isDateRangeComponent(component)) {
    const startDate = entity?.fields?.[component.startDateComponentId];
    const endDate = entity?.fields?.[component.endDateComponentId];
    return DateRangeField.fromFieldJson({ start: startDate, end: endDate });
  }

  if (isNil(data)) {
    return null;
  }

  return (
    fieldFromComponentData(component, data, { refs, currentUser }) ??
    new GenericUntypedJsonBlobField(data)
  );
}
